import { render } from "./AuthTemplate.vue?vue&type=template&id=5b31b4fb&scoped=true"
import script from "./AuthTemplate.vue?vue&type=script&lang=js"
export * from "./AuthTemplate.vue?vue&type=script&lang=js"

import "./AuthTemplate.vue?vue&type=style&index=0&id=5b31b4fb&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b31b4fb"]])

export default __exports__